import { CapaPurchaseOrderStatus } from '@generated/graphql';

export const getHistoryStatusLabel = (
  status: CapaPurchaseOrderStatus
): '거래완료' | '진행중단' | '거래 진행중' => {
  switch (status) {
    case CapaPurchaseOrderStatus.PurchaseConfirmed: {
      return '거래완료';
    }
    case CapaPurchaseOrderStatus.CancelConfirmed:
    case CapaPurchaseOrderStatus.CancelledByAdmin:
    case CapaPurchaseOrderStatus.NotPaidCanceled:
    case CapaPurchaseOrderStatus.PaymentFailed:
    case CapaPurchaseOrderStatus.RefundConfirmed:
    case CapaPurchaseOrderStatus.RejectOrderByPartner: {
      return '진행중단';
    }
    default: {
      return '거래 진행중';
    }
  }
};
